const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  --goto-icon-color: var(--goto-text-02);
  --goto-icon-size: 20px;
}
:host .root {
  background-color: var(--goto-search-field-background);
  border: 1px solid transparent;
  gap: var(--goto-spacing-01);
  padding: 0 12px;
  position: relative;
  width: 100%;
}
:host [part=start] {
  align-items: center;
  display: inline-flex;
}
:host [part=end] {
  --goto-icon-size: 10px;
  align-items: center;
  bottom: 0;
  display: inline-flex;
  margin: auto;
  position: absolute;
  right: 1rem;
  top: 0;
}
:host [part=end] button {
  --goto-icon-color: var(--goto-ui-01);
  align-items: center;
  background-color: var(--goto-search-field-clear-icon-background);
  border: 1px solid transparent;
  border-radius: 50%;
  cursor: pointer;
  display: none;
  height: 1rem;
  justify-content: center;
  outline: 0;
  width: 1rem;
}
:host [part=end] button:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host input {
  max-width: 100%;
  outline: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--goto-text-01);
}
:host input::placeholder {
  color: var(--goto-type-color-secondary);
}

:host(:focus-within) .root {
  background-color: var(--goto-ui-06);
}
:host(:focus-within) [part=end] button {
  display: inline-flex;
}

:host([alignment=center]) .root {
  justify-content: center;
}
:host([alignment=center]) .control {
  width: auto;
}
:host([alignment=center]) [part=end] {
  margin: unset;
  position: relative;
}

:host(:hover:not([disabled])) .root {
  background: transparent;
  background-color: var(--goto-search-field-background);
  border-color: var(--goto-search-field-border-hover);
}

:host(:focus-within:hover:not([disabled])) .root {
  background: var(--goto-ui-06);
}

:host(:active:not([disabled])) .root {
  background: var(--goto-search-field-background-active);
}

:host:not([disabled]) .root:hover {
  border-color: var(--goto-field-02);
}

:host(:focus-within:not([disabled])) .root {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight-small);
}
:host(:focus-within:not([disabled])) .root input {
  max-width: 60%;
}

:host([disabled]) {
  --goto-icon-color: var(--goto-search-field-icon-disabled);
  opacity: var(--goto-search-field-opacity-disabled);
}
:host([disabled]) .root {
  background-color: var(--goto-search-field-background-disabled);
}
:host([disabled]) input {
  color: var(--goto-search-field-text-disabled);
}
:host([disabled]) input::placeholder {
  color: var(--goto-search-field-text-disabled);
}

:host([fullwidth]) {
  width: 100%;
}
:host([fullwidth]) .control {
  width: 100%;
}`; export default styles;